// src/services/audit.ts
import api from "./api";
import {
  AuditLog,
  AuditLogFilters,
  AuditLogResponse,
  AuditLogSummary,
  AuditLogStats,
  AuditFilterOptions,
} from "../types/audit";

export const auditService = {
  // Get audit logs with filtering and pagination
  getAuditLogs: async (
    filters: AuditLogFilters = {}
  ): Promise<AuditLogResponse> => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value.toString());
      }
    });

    const response = await api.get(`/audit/logs?${params}`);
    return response.data; // Due to interceptor, this is already { logs: [], pagination: {} }
  },

  // Get audit logs summary/dashboard data
  getAuditSummary: async (timeRange = 30): Promise<AuditLogSummary> => {
    const response = await api.get(`/audit/summary?timeRange=${timeRange}`);
    return response.data;
  },

  // Get specific user's activity
  getUserActivity: async (
    userId: string,
    timeRange = 30
  ): Promise<AuditLog[]> => {
    const response = await api.get(
      `/audit/user/${userId}?timeRange=${timeRange}`
    );
    return response.data;
  },

  // Get available filter options
  getFilterOptions: async (): Promise<AuditFilterOptions> => {
    const response = await api.get("/audit/filters");
    return response.data;
  },

  // Export audit logs
  exportAuditLogs: async (
    filters: { startDate?: string; endDate?: string; format?: string } = {}
  ): Promise<Blob> => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value.toString());
      }
    });

    const response = await api.get(`/audit/export?${params}`, {
      responseType: "blob",
    });

    return response.data;
  },

  // Get audit statistics
  getAuditStats: async (timeRange = 30): Promise<AuditLogStats> => {
    const response = await api.get(`/audit/stats?timeRange=${timeRange}`);
    return response.data;
  },
};
